<template>
  <div>
    <a-spin :spinning="loading">
      <a-card v-if="formulario_pdi && usuarioNoTieneIdEmp" size="small">
        <a-form :form="form">
          <a-row :gutter="[12,12]">
            <g-lookup :label="$t('Buscar empleado')"
                      :formItemConfig="{
                            'label-col': {},
                            'wrapper-col': {},
                            'has-feedback': false
                          }"
                      :selectedObj.sync="persona"
                      endpoint="empleados"
                      :params="{estado_activo: true}"
                      @change="empleadoSeleccionado">
            </g-lookup>
          </a-row>
        </a-form>
      </a-card>
      <br>
      <a-card hoverable v-if="formulario_pdi && id_emp">
        <a-card-meta :title="persona.nombre">
          <div slot="description">
            {{persona.cargo}}
            <br>
            {{persona.area}}
            <br>
            {{persona.nombre_jefe}}
            <br>
            {{fechaActual}}
          </div>
          <a-avatar
            slot="avatar"
            :src="profileSrc"
            @click="agrandarImg()"
            :size="81"
          />
        </a-card-meta>
        <template class="ant-card-actions" slot="actions">
          <a-progress style="width: 80%" :percent="100" :strokeColor="{
        '0%': '#108ee9',
        '100%': '#87d068',
      }"/>
        </template>
      </a-card>
      <a-modal @ok="() => {this.expandImg = false}" :cancel-button-props="{props: { disabled: true } }" width="400px"
               v-model="expandImg" :title="persona.nombre">
        <a-card hoverable style="width: auto">
          <img
            slot="cover"
            :src="profileSrc"
          />
        </a-card>
      </a-modal>
      <a-card size="small" v-if="formulario_pdi && id_emp">
        <a-button @click="diligenciarFormulario" type="primary">
          Mega personal
        </a-button>
        <a-button :loading="loadingDownloadPdf" style="background-color: #C51414; color: white"
                  icon="file-pdf" @click="downloadFilePDFOnlyOne()">
          Descargar reporte
        </a-button>
      </a-card>
      <div v-if="!formulario_pdi">
        <a-result
          status="warning"
          title="PDI no configurado actualmente"
          sub-title="A continuación se muestra la razón por la cual no puede acceder a esta pantalla"
        >
          <div class="desc">
            <p style="font-size: 16px;">
              <strong>Situación:</strong>
            </p>
            <p>
              <a-icon :style="{ color: 'red' }" type="close-circle"/>
              Es posible que aún no se haya configurado este formulario o que simplemente se encuentre en estado
              inactivo.
            </p>
          </div>
        </a-result>
      </div>
      <br>
      <a-tabs v-if="formulario_pdi && id_emp" default-active-key="1">
        <a-tab-pane key="1">
      <span slot="tab">
        <a-icon type="reconciliation"/>
        Causas e impactos de las competencias a desarrollar
      </span>
          <g-master :name="masterPdiFeedback.endpoint"
                    :endpoint="masterPdiFeedback.endpoint"
                    :tableSetup="masterPdiFeedback.tableSetup"
                    :parentData="parentCausasEImpactos"
                    modalWidth="80%"
                    :modalFieldsSetup="masterPdiFeedback.modalFieldsSetup"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="competency"
                              :label="$t('Competencia')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_competency',{ rules: [{ required: true, message: 'Valor requerido' }]}]">
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">

                  <a-form-item v-bind="fiOptions">
                    <div style="line-height: normal; color: #000000D9">
                      Posibles causas: (Razones internas - externas que pudieran estar afectando el desarrollo de la
                      competencia, comportamientos puntuales que podía fortalecer):
                    </div>
                    <a-textarea autoSize
                                v-decorator="['answer1', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions">
                    <div style="line-height: normal; color: #000000D9">
                      Importancia de desarrollar esta competencia: (¿Cómo me esta afectando en mi trabajo no tenerla en
                      el nivel de desarrollo esperado?, ¿Por qué es importante desarrollar esta competencia frente a la
                      evolución de mi rol y mi nivel de contribución):
                    </div>
                    <a-textarea autoSize
                                v-decorator="['answer2', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions">
                    <div style="line-height: normal; color: #000000D9">
                      ¿Cómo espero que sea mi desempeño en esta competencia, donde se podrá evidenciar claramente el
                      fortalecimiento de la competencia? (después del plan):
                    </div>
                    <a-textarea autoSize
                                v-decorator="['answer3', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
        <a-tab-pane key="2">
      <span slot="tab">
        <a-icon type="solution"/>
        Plan de acción
      </span>
          <a-row :gutter="[8, 8]">
            <a-col :xs="{span: 24 }" :sm="{span: 4}" :md="{span: 4}" :lg="{span:4}">
              <a-alert
                style="height: 320px; text-align: center;  margin: 0 auto;"
                type="error"
              >
                <div slot="message">
                  <br>
                  <br>
                  <br>
                  PLAN 70%
                </div>
                <div slot="description">
                  <strong>Aprendizaje a través de la experiencia:</strong> Nuevos retos, responsabilidades, exposición,
                  proyectos y nuevas asignaciones.
                </div>
              </a-alert>
            </a-col>
            <a-col :xs="{span: 24 }" :sm="{span: 20}" :md="{span: 20}" :lg="{span:20}">
              <g-master :name="masterActionPlan.endpoint"
                        :parentData="parentPlan70"
                        modalWidth="80%"
                        :endpoint="masterActionPlan.endpoint"
                        :tableSetup="masterActionPlan.tableSetup"
                        :modalFieldsSetup="masterActionPlan.modalFieldsSetup"
              >
                <template slot="masterModal" slot-scope="{record}">
                  <a-row :gutter="[16,16]">
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="competency"
                                  :label="$t('Competencia')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['id_competency',{ rules: [{ required: true, message: 'Valor requerido' }]}]">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Acciones para poner en práctica')">
                        <a-textarea autoSize
                                    v-decorator="['actions_implement', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Objetivo de desarrollo')">
                        <a-textarea autoSize
                                    v-decorator="['objectives', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Apoyo necesario')">
                        <a-textarea autoSize
                                    v-decorator="['support', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Fecha')" v-bind="fiOptions">
                        <a-date-picker style="width: 100%"
                                       valueFormat="Y-MM-DD HH:mm:ss"
                                       v-decorator="['date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </template>
              </g-master>
            </a-col>
          </a-row>
          <a-row :gutter="[8, 8]">
            <a-col :xs="{span: 24 }" :sm="{span: 4}" :md="{span: 4}" :lg="{span:4}">
              <a-alert
                style="height: 320px; text-align: center;  margin: 0 auto;"
                type="warning"
              >
                <div slot="message">
                  <br>
                  <br>
                  <br>
                  PLAN 20%
                </div>
                <div slot="description">
                  <strong>Aprendizaje a través de otros:</strong> Sesiones de retroalimentación con el líder, colegas y
                  clientes; assessment, mentoring, coaching y actividades de observación.
                </div>
              </a-alert>
            </a-col>
            <a-col :xs="{span: 24 }" :sm="{span: 20}" :md="{span: 20}" :lg="{span:20}">
              <g-master :name="masterActionPlan.endpoint"
                        :parentData="parentPlan20"
                        modalWidth="80%"
                        :endpoint="masterActionPlan.endpoint"
                        :tableSetup="masterActionPlan.tableSetup"
                        :modalFieldsSetup="masterActionPlan.modalFieldsSetup"
              >
                <template slot="masterModal" slot-scope="{record}">
                  <a-row :gutter="[16,16]">
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="competency"
                                  :label="$t('Competencia')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['id_competency',{ rules: [{ required: true, message: 'Valor requerido' }]}]">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Acciones para poner en práctica')">
                        <a-textarea autoSize
                                    v-decorator="['actions_implement', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Objetivo de desarrollo')">
                        <a-textarea autoSize
                                    v-decorator="['objectives', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Apoyo necesario')">
                        <a-textarea autoSize
                                    v-decorator="['support', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Fecha')" v-bind="fiOptions">
                        <a-date-picker style="width: 100%"
                                       valueFormat="Y-MM-DD HH:mm:ss"
                                       v-decorator="['date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </template>
              </g-master>
            </a-col>
          </a-row>
          <a-row :gutter="[8, 8]">
            <a-col :xs="{span: 24 }" :sm="{span: 4}" :md="{span: 4}" :lg="{span:4}">
              <a-alert
                style="height: 320px; text-align: center;  margin: 0 auto;"
                type="info"
              >
                <div slot="message">
                  <br>
                  <br>
                  <br>
                  PLAN 10%
                </div>
                <div slot="description">
                  <strong>Aprendizaje a través de programas de educación:</strong> Capacitaciones, cursos, e-learning,
                  autoestudio y lecturas relacionadas.
                </div>
              </a-alert>
            </a-col>
            <a-col :xs="{span: 24 }" :sm="{span: 20}" :md="{span: 20}" :lg="{span:20}">
              <g-master :name="masterActionPlan.endpoint"
                        :parentData="parentPlan10"
                        modalWidth="80%"
                        :endpoint="masterActionPlan.endpoint"
                        :tableSetup="masterActionPlan.tableSetup"
                        :modalFieldsSetup="masterActionPlan.modalFieldsSetup"
              >
                <template slot="masterModal" slot-scope="{record}">
                  <a-row :gutter="[16,16]">
                    <a-col v-bind="colOptions">
                      <g-dropdown endpoint="competency"
                                  :label="$t('Competencia')"
                                  :formItemConfig="fiOptions"
                                  :decorator="['id_competency',{ rules: [{ required: true, message: 'Valor requerido' }]}]">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Acciones para poner en práctica')">
                        <a-textarea autoSize
                                    v-decorator="['actions_implement', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Objetivo de desarrollo')">
                        <a-textarea autoSize
                                    v-decorator="['objectives', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item v-bind="fiOptions" :label="$t('Apoyo necesario')">
                        <a-textarea autoSize
                                    v-decorator="['support', { rules: [{ required: false, message: 'Valor requerido'}] }]"/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="colOptions">
                      <a-form-item :label="$t('Fecha')" v-bind="fiOptions">
                        <a-date-picker style="width: 100%"
                                       valueFormat="Y-MM-DD HH:mm:ss"
                                       v-decorator="['date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </template>
              </g-master>
            </a-col>
          </a-row>
          <br>
          <br>
          <br>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
    <a-spin :spinning="loadingObservacionesGenerales">
      <div v-if="formulario_pdi && id_emp">
        <a-form-model :model="observaciones">
          <a-form-model-item :label="$t('Observaciones generales')">
            <a-input v-model="observaciones.observacionesGenerales" type="textarea"/>
          </a-form-model-item>
        </a-form-model>
        <a-button @click="guardarObservacionesGenerales" type="primary">
          Guardar observaciones
        </a-button>
      </div>
    </a-spin>
    <br>
    <br>
    <br>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        loadingModalCompetencias: false,
        competenciasPorEmpleado: [],
        loadingObservacionesGenerales: false,
        modalConfiguracion: false,
        modalCompetencias: false,
        preguntasDisponibles: [],
        loadingDownloadPdf: false,
        observaciones: {
          observacionesGenerales: null
        },
        fechaActual: moment().format('DD-MM-Y'),
        expandImg: false,
        defaultPicture: require('./../../assets/anon_profile.png'),
        profileSrc: require('./../../assets/anon_profile.png'),
        loading: false,
        id_emp: null,
        persona: {},
        formulario_pdi: null,
        form: this.$form.createForm(this, {
          name: 'frmPdi'
        }),
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'pdi_questions',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Descripición', dataIndex: 'description', sorter: true},
              {title: 'Estado', dataIndex: 'estado', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'description'},
            {name: 'status', type: 'boolean'}
          ]
        },
        masterPdiFeedback: {
          endpoint: 'pdi_feedback',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Competencia', dataIndex: 'competencia', sorter: true},
              {
                title: 'Posibles causas: (Razones internas - externas que pudieran estar afectando  el desarrollo de la competencia, comportamientos puntuales que podía fortalecer)',
                dataIndex: 'answer1',
                sorter: true,
                width: 450
              },
              {
                title: 'Importancia de desarrollar esta competencia:  (¿Cómo me esta afectando en mi trabajo no tenerla en el nivel de desarrollo esperado?, ¿Por qué es importante desarrollar esta competencia frente a la evolución de mi rol y mi nivel de contribución)',
                dataIndex: 'answer2',
                sorter: true,
                width: 450
              },
              {
                title: '¿Cómo espero que sea mi desempeño en esta competencia, donde se podrá evidenciar claramente el fortalecimiento de la competencia? (después del plan)',
                dataIndex: 'answer3',
                sorter: true,
                width: 450
              }
            ]
          },
          modalFieldsSetup: [
            {name: 'id_competency'},
            {name: 'answer1'},
            {name: 'answer2'},
            {name: 'answer3'}
          ]
        },
        masterActionPlan: {
          endpoint: 'pdi_action_plan',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Competencia', dataIndex: 'competencia', sorter: true},
              {title: 'Acciones para poner en práctica', dataIndex: 'actions_implement', sorter: true},
              {title: 'Objetivo de desarrollo', dataIndex: 'objectives', sorter: true},
              {title: 'Apoyo necesario', dataIndex: 'support', sorter: true},
              {title: 'Fecha', dataIndex: 'fecha', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'actions_implement'},
            {name: 'date'},
            {name: 'id_competency'},
            {name: 'id_emp'},
            {name: 'objectives'},
            {name: 'support'},
            {name: 'type'}
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.consultaFormulario()
    },
    methods: {
      empleadoSeleccionado (empleado) {
        this.id_emp = empleado
        this.consultarObservacionesGenerales()
      },
      guardarObservacionesGenerales () {
        this.loadingObservacionesGenerales = true
        this.httpClient.getInstance().post('action_plan/guardar_observaciones_generales', {
          id_emp: this.id_emp,
          type: 'OBG',
          observation: this.observaciones.observacionesGenerales
        }).then(response => {
          this.observaciones.observacionesGenerales = response.data.observations
          this.loadingObservacionesGenerales = false
          Mensajes.success('Correcto', 'Se guardaron sus observaciones con éxito.')
        })
          .catch(() => {
            this.loadingObservacionesGenerales = false
            Mensajes.error('Error', 'No fue posible guardar las observaciones.')
          })
      },
      downloadFilePDFOnlyOne () {
        this.loadingDownloadPdf = true
        this.httpClient.getInstance().post('pdi/generar_reporte_pdf', {
          id_emp: this.id_emp
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
          Mensajes.success('Correcto', 'Se descargó su archivo con éxito.')
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          this.loadingDownloadPdf = false
        })
      },
      consultarObservacionesGenerales () {
        this.loadingObservacionesGenerales = true
        this.httpClient.getInstance().post('action_plan/consultarObservacionesGenerales', {
          id_emp: this.id_emp,
          type: 'OBG'
        }).then(response => {
          this.observaciones.observacionesGenerales = response.data.observations
          this.loadingObservacionesGenerales = false
        })
          .catch(() => {
            this.loadingObservacionesGenerales = false
            Mensajes.error('Error', 'No fue posible guardar las observaciones.')
          })
      },

      consultaFormulario () {
        this.loading = true
        this.httpClient.getInstance().get('consultar_formulario_pdi').then(response => {
          this.formulario_pdi = response.data
        }).catch().then(() => {
          this.loading = false
        })
      },
      diligenciarFormulario () {
        let fnAbrirVentana = (idFormFillout) => {
          let routeData = this.$router.resolve({
            name: 'FormFillout',
            query: {fillOutId: idFormFillout}
          })
          window.open(routeData.href, '_blank')
        }
        this.httpClient.getInstance().post('person_requisition_evaluator/formulario', {
          id_form: this.formulario_pdi.id,
          id_person: this.persona.id_person
        }).then(response => {
          fnAbrirVentana(response.data.id_forms_fillout)
        })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible regisrar el formulario.')
          })
      },
      agrandarImg () {
        this.expandImg = true
      },
      loadPersonPicture (idPerson) {
        this.profileSrc = this.defaultPicture
        this.httpClient.getInstance().get('picture_service/render/profile/' + idPerson, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
      }
    },
    computed: {
      usuarioNoTieneIdEmp () {
        if (this.$store.state.userInfo.id_emp == '-1') {
          return true
        } else {
          this.persona.id_person = this.$store.state.userInfo.id_person
          this.id_emp = this.$store.state.userInfo.id_emp
          this.loadPersonPicture(this.$store.state.userInfo.id_person)
          this.persona.nombre = this.$store.state.userInfo.employee.nombre
          this.persona.cargo = this.$store.state.userInfo.employee.cargo
          this.consultarObservacionesGenerales()
          return false
        }
      },
      parentCausasEImpactos () {
        return {
          id_emp: this.id_emp
        }
      },
      parentPlan70 () {
        return {id_emp: this.id_emp, type: '70'}
      },
      parentPlan20 () {
        return {id_emp: this.id_emp, type: '20'}
      },
      parentPlan10 () {
        return {id_emp: this.id_emp, type: '10'}
      }
    },
    watch: {
      persona () {
        this.persona && this.loadPersonPicture(this.persona.id_person)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/PDI/PDI.vue